import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ element, restricted }) => {
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  // If the user is logged in and the route is restricted (like /login), redirect them
  if (isLoggedIn && restricted) {
    return <Navigate to="/home" />; // Redirect to protected route if already logged in
  }

  // Otherwise, render the public component
  return element;
};

export default PublicRoute;
